<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00037.installation.desinfection.titre' | translate"
      [description]="'P00037.installation.desinfection.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00037.installation.consignemanuel' | translate"
      [titleListe]="'P00037.installation.consignemanuel' | translate"
      [description]="
        'P00037.installation.consignemanuel.description' | translate
      "
      [value]="actionStack!.getValue('elPConsigneManuel')"
      [liste]="P00037ConsigneManuel"
      [warningMode]="getProductDeviceTableFromPool()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Parametrage1,
          'elPConsigneManuel',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (hasProduitP00032()) {
      <app-label-configuration
        [title]="'P00037.installation.regulation' | translate"
        [titleListe]="'P00037.installation.regulation.value' | translate"
        [information]="P00037ESPInstallationClModal"
        [value]="actionStack!.getValue('elPConsigneRX')"
        [liste]="P00037ConsigneRegulationRxEnum"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.SALT_Parametrage1,
            'elPConsigneRX',
            $event,
            null
          )
        "
      >
      </app-label-configuration>

      <app-label-configuration
        [titleListe]="'P00037.installation.hysteresis.value' | translate"
        [value]="actionStack!.getValue('elPHysteresisRegulationRX')"
        [liste]="P00037HysteresisRegulationRx"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.SALT_Parametrage1,
            'elPHysteresisRegulationRX',
            $event,
            null
          )
        "
      >
      </app-label-configuration>

      <app-switch-configuration
        [nameCustom]="'P00037.installation.automaintien.value' | translate"
        [value]="
          actionStack!.getValue('elIActivationFonctionPrioriteAutoMaintien') !==
          0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.SALT_Installation,
            'elIActivationFonctionPrioriteAutoMaintien',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-label-description
        [description]="'P00037.installation.regulation.description' | translate"
      ></app-label-description>
    }

    <app-information-title
      [title]="'P00037.installation.horloge' | translate"
      [information]="openEnSavoirPlus"
    ></app-information-title>

    <app-two-choices-control
      [firstLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.day'
          | translate
      "
      [firstValue]="0"
      [secondLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.week'
          | translate
      "
      [secondValue]="1"
      [value]="actionStack!.getValue('elPTypeHorloge')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Parametrage1,
          'elPTypeHorloge',
          $event,
          null
        )
      "
    >
    </app-two-choices-control>

    @if (this.actionStack!.getValue('elPTypeHorloge') === 0) {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingsClockScreen()"
      >
      </app-larged-link>
    } @else {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingClockWeekScreen()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="'P00037.installation.descriptionHorloge' | translate"
    ></app-label-description>

    <app-switch-configuration
      [title]="'P00037.installation.comportement' | translate"
      [nameCustom]="'P00037.installation.comportement.value' | translate"
      [description]="'P00037.installation.comportement.description' | translate"
      [value]="
        actionStack!.getValue('elIActivationFonctionPrioriteElectrolyse') !== 0
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Installation,
          'elIActivationFonctionPrioriteElectrolyse',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-switch-configuration
      [title]="'P00037.installation.comportementBoost' | translate"
      [nameCustom]="'P00037.installation.comportementBoost.value' | translate"
      [description]="
        'P00037.installation.comportementBoost.description' | translate
      "
      [value]="
        actionStack!.getValue('elIActivationFonctionPrioriteBoost') !== 0
      "
      [warningMode]="
        getLabelConfigurationWarningModeFromACU(this.getPool(), 9)!
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Installation,
          'elIActivationFonctionPrioriteBoost',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-label-configuration
      [title]="'P00037.installation.volet' | translate"
      [titleListe]="'P00037.installation.abaissement' | translate"
      [description]="
        'P00037.installation.abaissementProduction.description' | translate
      "
      [value]="actionStack!.getValue('elPTauxAbaissementVolet')"
      [liste]="P00037TauxAbaissement"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Parametrage1,
          'elPTauxAbaissementVolet',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
